(function () {
  function x_mark_visible_blocks() {
    const blocks = document.querySelectorAll('.blocks > *');
    for (let i = 0; i < blocks.length; i++) {
      const bounding = blocks[i].getBoundingClientRect();
      const height = (window.innerHeight || document.documentElement.clientHeight);
      if (bounding.top && bounding.top >= 0 && bounding.top <= height && blocks[i].classList) {
        blocks[i].classList.add('is-in-viewport');
      }
    }
  }
  window.addEventListener('scroll', (e) => {
    x_mark_visible_blocks();
  }, false);
  x_mark_visible_blocks();
}());
